<template>
  <div class="content-ct">
    <el-row>
      <el-col :xs="9" :sm="9" :md="8" :lg="6">
        <game-campaign-content-nav
          :menu-items="gameRulesNavigation"
          :default-active="activeItemTitle"
          @update="setActiveItem"
        />
      </el-col>
      <el-col :xs="15" :sm="15" :md="16" :lg="18">
        <component
          v-if="activeItem"
          :is="activeItem.component"
          :is-completed="activeItem.isCompleted"
          :is-read-only="isReadOnly"
          :is-creation-mode="isCreationMode"
          :save-flag="saveFlag"
          @goToNextStep="goToNextStep"
          @check="$emit('check', $event)"
          @checkChanges="checkChanges"
          :game-campaign-id="gameCampaignId"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import GameCampaignContentNav from '@/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'
import GameRoundsPredictionsForm from '@/modules/gamification/components/games-campaigns/game-rules/GameRoundsPredictionsForm.vue'
import GameScoringForm from '@/modules/gamification/components/games-campaigns/game-rules/GameScoringForm.vue'
import { updateNavigationState } from '@/modules/gamification/helpers'
import { customConfirm } from '@/core/helpers'

export default {
  name: 'GameStepGameRules',

  components: {
    GameCampaignContentNav,
    GameRoundsPredictionsForm,
    GameScoringForm
  },

  props: {
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isCreationMode: {
      type: Boolean,
      required: true
    },
    completedSubSteps: {
      type: Array,
      required: true
    },
    currentSubStep: {
      type: String,
      default: GameCreationSubSteps.ROUNDS_AND_PREDICTIONS
    },
    saveFlag: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    }
  },

  data() {
    return {
      activeItem: null,
      navigation: [
        {
          title: this.$t('Gamification_GameStepGameRules_RoundsAndPredictions'),
          step: GameCreationSubSteps.ROUNDS_AND_PREDICTIONS,
          component: GameRoundsPredictionsForm,
          isCompleted: false
        },
        {
          title: this.$t('Gamification_GameStepGameRules_Scoring'),
          step: GameCreationSubSteps.SCORING,
          component: GameScoringForm,
          isCompleted: false
        }
      ],
      hasChanges: false
    }
  },

  computed: {
    gameRulesNavigation() {
      return this.navigation
    },
    activeItemTitle() {
      return this.activeItem ? this.activeItem.title : null
    }
  },
  mounted() {
    this.updateNavigation()
  },
  watch: {
    currentSubStep() {
      this.updateNavigation()
    }
  },
  methods: {
    setActiveItem(tab) {
      if (!this.hasChanges) {
        this.activeItem = tab
        return
      }

      customConfirm(
        this.$t('Gamification_LeavingWithoutSaving'),
        this.$t('Gamification_LeavingWithoutSavingDescription'),
        this.$t('Gamification_Confirm_Button_Leave')
      ).then(() => {
        this.activeItem = tab
      })
    },
    updateNavigation() {
      this.activeItem =
        this.gameRulesNavigation.find(
          item => item.step === this.currentSubStep
        ) || this.gameRulesNavigation[0]

      if (this.isCreationMode) {
        updateNavigationState(
          this.navigation,
          this.completedSubSteps,
          this.currentSubStep
        )
      }
    },
    goToNextStep(step) {
      const stepIndex = this.gameRulesNavigation.findIndex(
        item => item.step === step
      )
      const isLastStep = stepIndex + 1 === this.gameRulesNavigation.length
      if (stepIndex !== -1 && isLastStep) {
        EventBus.$emit('campaign-create-next-step')
      }

      EventBus.$emit('updateStep', step)
    },
    checkChanges(payload) {
      this.hasChanges = payload
      this.$emit('checkChanges', payload)
    }
  }
}
</script>

<style scoped>
.content-ct {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameStepGameRules.vue